import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps, InputTextComponent } from '@sheerid/jslib';

const ProjectNameComponent = ({ value, isErrored, onChange, placeholder = '' }: FormFieldComponentProps) => {
    return (
        <div className="sid-field sid-project-name">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-project-name">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="step.personalInfo.projectNameLabel"
                        defaultMessage="Open Source Organization or Project Name"
                    />
                </div>
            </label>

            <InputTextComponent
                className={
                    `sid-text-input sid-text-input--required
                        sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                }
                isErrored={isErrored}
                id="sid-project-name"
                name="sid-project-name"
                type="text"
                value={value}
                onChange={(e: any) => onChange(e.target.value)}
                placeholder={placeholder}
                refId="projectName"
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidProjectName"
                            defaultMessage="Invalid project name"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  ProjectNameComponent };
